import React from 'react';
// import { appInsights, reactPlugin } from '../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import cn from 'clsx';
import { gritComponentStyles } from './gritComponentStyles';
import ModeEditOutlineSharpIcon from '@mui/icons-material/ModeEditOutlineSharp';
import DeleteIcon from '@mui/icons-material/Delete';
import { InputClaim } from '../../xmlParsing/interfaces';

interface ClaimListProps {
  list: InputClaim[];
  onEditHandler: (val: string) => void;
  onDeleteHandler: (val: string) => void;
}

function ClaimList({ list, onEditHandler, onDeleteHandler }: ClaimListProps) {
  const classes = gritComponentStyles();
  return (
    <>
      {list &&
        list.map((el: InputClaim) => {
          return (
            <div key={el.claimTypeReferenceId} className={cn(classes.policyEntry, classes.flexRow)}>
              <span className={classes.label}>{el.claimTypeReferenceId} </span>
              <ModeEditOutlineSharpIcon
                onClick={() => onEditHandler(el['claimTypeReferenceId'])}
                className={classes.icon}
                color="primary"
              />
              <DeleteIcon
                onClick={() => {
                  window.confirm(
                    'Are you sure you want to delete ' + el['claimTypeReferenceId'] + '? This cannot be undone.',
                  ) && onDeleteHandler(el['claimTypeReferenceId']);
                }}
                className={classes.icon}
                color="error"
              />
            </div>
          );
        })}
    </>
  );
}

// export default withAITracking(reactPlugin, ClaimList);
export default ClaimList;
